import { render } from "./HelpLinks.vue?vue&type=template&id=314a854a&scoped=true"
import script from "./HelpLinks.vue?vue&type=script&lang=js"
export * from "./HelpLinks.vue?vue&type=script&lang=js"

import "./HelpLinks.vue?vue&type=style&index=0&id=314a854a&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314a854a"]])

export default __exports__